// extracted by mini-css-extract-plugin
module.exports = {"panelHeader":"PanelHeader_panelHeader__Sp7_b","text":"PanelHeader_text__sxNHR","img":"PanelHeader_img__0Wig5"};